import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import Login from "../pages/Login/Login";
import Auxiliares from "../pages/TabelasAuxiliares/Auxiliares";
import PasswordDefinition from "../pages/Login/PasswordDefinition";
import AuxiliaresItems from "../pages/TabelasAuxiliares/AuxiliaresItems";
import Organization from "../pages/Organization/Organization";
import NewOrganization from "../pages/Organization/controller/NewOrganization";
import EditOrganization from "../pages/Organization/controller/EditOrganization";
import Roles from "../pages/Roles/Roles";
import NewRole from "../pages/Roles/controller/NewRole";
import EditRole from "../pages/Roles/controller/EditRole";
import Users from "../pages/Users/Users";
import NewUser from "../pages/Users/controller/NewUser";
import EditUser from "../pages/Users/controller/EditUser";
import EditAccount from "../pages/EditAccount/EditAccount";
import IndicatorManagement from "../pages/IndicatorManagement/IndicatorManagement";
import NewIndicator from "../pages/IndicatorManagement/controller/NewIndicator";
import Indicator from "../pages/Indicator/Indicator";
import EditIndicator from "../pages/IndicatorManagement/controller/EditIndicator";
import UploadDataIndicator from "../pages/IndicatorManagement/controller/UploadDataIndicator";
import Bulletins from "../pages/Bulletins/Bulletins";
import FieldOccurrences from "../pages/FieldOccurrences/FieldOccurrences";
import NewFieldOccurrences from "../pages/FieldOccurrences/controller/NewFieldOccurrences";
import Landing from "../pages/Landing/Landing";
import LandingLayout from "../components/template/Layout/LandingLayout";
import BulletinsDownload from "../pages/Bulletins/bulletinPDF/BulletinsDownload";
import Dashboard from "../pages/Dashboard/Dashboard";
import Documents from "../pages/Documents/Documents";
import ForbiddenPage from "../pages/Errors/ForbiddenPage";
import CriticalErrorPage from "../pages/Errors/CriticalErrorPage";
import NotFoundPage from "../pages/Errors/NotFoundPage";
import {
  FORBIDDEN_ROUTE,
  INTERNAL_ERROR_ROUTE,
  NOT_FOUND_ROUTE,
} from "../utils/endpoints";
import GeneralLayout from "../components/template/Layout/GeneralLayout";
import LoginLayout from "../components/template/Layout/LoginLayout";
import { useAuth } from "../provider/AuthProvider";

const RoutesWrapper = () => {
  const { auth } = useAuth();
  const isAuthenticated = auth.isAuthenticated;

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {!isAuthenticated && (
          <>
            <Route element={<LandingLayout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/documentos" element={<Documents />} />
              <Route path="/*" element={<Navigate to="/" />} />
            </Route>

            <Route element={<LoginLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/definir-senha" element={<PasswordDefinition />} />
            </Route>
          </>
        )}

        {isAuthenticated && (
          <Route element={<GeneralLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/utilizadores" element={<Users />} />
            <Route
              path="/utilizadores/criar-utilizador"
              element={<NewUser />}
            />
            <Route path="/utilizadores/:id" element={<EditUser />} />

            <Route path="/perfis" element={<Roles />} />
            <Route path="/perfis/criar-perfis" element={<NewRole />} />
            <Route path="/perfis/:id" element={<EditRole />} />

            <Route path="/entidades" element={<Organization />} />
            <Route
              path="/entidades/criar-entidades"
              element={<NewOrganization />}
            />
            <Route path="/entidades/:id" element={<EditOrganization />} />

            <Route path="/tabelas-auxiliares" element={<Auxiliares />} />
            <Route
              path="/tabelas-auxiliares/:table"
              element={<AuxiliaresItems />}
            />

            <Route
              path="/gestao-de-indicadores/criar-indicadores"
              element={<NewIndicator />}
            />
            <Route
              path="/gestao-de-indicadores/carregar-dados-no-sisan"
              element={<UploadDataIndicator />}
            />
            <Route
              path="/gestao-de-indicadores/:id"
              element={<EditIndicator />}
            />
            <Route
              path="/gestao-de-indicadores"
              element={<IndicatorManagement />}
            />

            <Route path="/minha-conta" element={<EditAccount />} />
            <Route path="/indicadores" element={<Indicator />} />
            <Route path="/boletins" element={<Bulletins />} />

            <Route
              path="/ocorrencias-no-terreno"
              element={<FieldOccurrences />}
            />
            <Route
              path="/ocorrencias-no-terreno/criar-ocorrencias-no-terreno"
              element={<NewFieldOccurrences />}
            />

            <Route path="/documentos" element={<Documents />} />

            <Route path={FORBIDDEN_ROUTE} element={<ForbiddenPage />} />
            <Route
              path={INTERNAL_ERROR_ROUTE}
              element={<CriticalErrorPage />}
            />
            <Route path={NOT_FOUND_ROUTE} element={<NotFoundPage />} />
            <Route path="/*" element={<NotFoundPage />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/login" element={<Navigate to="/dashboard" />} />
          </Route>
        )}

        <Route path="/boletins/download/:id" element={<BulletinsDownload />} />
      </>,
    ),
  );

  return <RouterProvider router={router} />;
};

export default RoutesWrapper;
